import React, { useEffect, useMemo, useState } from 'react';
import api, { cacheGet, cacheSet } from '../api';

function LineChart({ series }) {
  const safe = useMemo(() => (Array.isArray(series) ? series : []), [series]);

  const pts = useMemo(() => {
    if (!safe.length) return '';
    const w = 560;
    const h = 220;
    const pad = 24;
    const max = Math.max(...safe.map((s) => Number(s.logs) || 0), 1);
    return safe
      .map((s, i) => {
        const x = pad + (i * (w - pad * 2)) / Math.max(safe.length - 1, 1);
        const y = h - pad - ((Number(s.logs) || 0) / max) * (h - pad * 2);
        return `${x},${y}`;
      })
      .join(' ');
  }, [safe]);

  if (!safe.length) return <div className="rm-empty">Нет данных</div>;

  const w = 560;
  const h = 220;
  const pad = 24;
  const max = Math.max(...safe.map((s) => Number(s.logs) || 0), 1);

  return (
    <svg viewBox="0 0 560 240" width="100%" height="240">
      {pts && <polyline fill="none" stroke="#3B82F6" strokeWidth="3" points={pts} />}
      {safe.map((s, i) => {
        const x = pad + (i * (w - pad * 2)) / Math.max(safe.length - 1, 1);
        const y = h - pad - ((Number(s.logs) || 0) / max) * (h - pad * 2);
        return <circle key={s.day || i} cx={x} cy={y} r="4" fill="#3B82F6" />;
      })}
      {safe.map((s, i) => {
        const x = pad + (i * (w - pad * 2)) / Math.max(safe.length - 1, 1);
        return (
          <text key={`t-${i}`} x={x} y={235} textAnchor="middle" fontSize="11" fill="#94A3B8">
            {(s.day || '').slice(5).replace('-', '.')}
          </text>
        );
      })}
    </svg>
  );
}

function BarChart({ series }) {
  const safe = Array.isArray(series) ? series : [];
  if (!safe.length) return <div className="rm-empty">Нет данных</div>;

  const max = Math.max(...safe.map((s) => Number(s.wallets) || 0), 1);

  return (
    <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10, height: 220, padding: '8px 4px 28px' }}>
      {safe.map((s, i) => (
        <div key={s.day || i} style={{ flex: 1, textAlign: 'center' }}>
          <div
            style={{
              height: `${Math.max(8, ((Number(s.wallets) || 0) / max) * 170)}px`,
              background: 'linear-gradient(180deg,#4ADE80,#16A34A)',
              borderRadius: '8px 8px 4px 4px',
            }}
            title={String(s.wallets ?? 0)}
          />
          <div style={{ marginTop: 8, fontSize: 11, color: '#94A3B8' }}>
            {(s.day || '').slice(5).replace('-', '.')}
          </div>
        </div>
      ))}
    </div>
  );
}

export default function Home() {
  const [data, setData] = useState(() => cacheGet('home', null));

  useEffect(() => {
    api
      .get('/home')
      .then((r) => {
        const next = r.data && typeof r.data === 'object' && !Array.isArray(r.data) ? r.data : {};
        setData(next);
        cacheSet('home', next);
      })
      .catch(() => {
        /* keep cached home — don't flash zeros */
        setData((prev) => prev || cacheGet('home', {}));
      });
  }, []);

  const d = data || {};
  const series = Array.isArray(d.series) ? d.series : [];
  const walletsSeries = Array.isArray(d.wallets_series) ? d.wallets_series : series;

  return (
    <div>
      <div className="rm-kpi-grid">
        <div className="rm-card rm-kpi">
          <div className="label">ВСЕГО ЛОГОВ</div>
          <div className="value">{(Number(d.total_logs) || 0).toLocaleString('ru-RU')}</div>
          <span className={`rm-pill ${(Number(d.growth_pct) || 0) >= 0 ? 'up' : 'down'}`}>
            {(Number(d.growth_pct) || 0) >= 0 ? '+' : ''}{(Number(d.growth_pct) || 0).toFixed(1)}%
          </span>
        </div>
        <div className="rm-card rm-kpi">
          <div className="label">КОШЕЛЬКИ</div>
          <div className="value">{(Number(d.wallets) || 0).toLocaleString('ru-RU')}</div>
          <span className="rm-pill up">отстук</span>
        </div>
        <div className="rm-card rm-kpi">
          <div className="label">РОСТ ЗА СУТКИ</div>
          <div className="value">{(Number(d.growth_today) || 0).toLocaleString('ru-RU')}</div>
          <span className="rm-pill up">сегодня</span>
        </div>
      </div>

      <div className="rm-charts">
        <div className="rm-card rm-chart-card">
          <h3>Рост количества логов относительно даты</h3>
          <LineChart series={series} />
        </div>
        <div className="rm-card rm-chart-card">
          <h3>Кошельки по дням</h3>
          <BarChart series={walletsSeries} />
        </div>
      </div>
    </div>
  );
}
